import React, { ReactNode } from "react";
import { Box, Typography } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import { BackButton } from "./BackButton";

interface Props {
  variant: Variant;
  returnTo?: string;
  children: ReactNode;
}
export const Heading = ({ variant, returnTo, children }: Props): JSX.Element => {
  return (
    <Box py={2} display="flex" alignItems="center" justifyItems="flex-start">
      {returnTo && <BackButton returnTo={returnTo} text={false} />}
      <Typography variant={variant} style={{ margin: 0 }}>
        {children}
      </Typography>
    </Box>
  );
};
